export enum EApiPathParams {
  Sep24GUID = '<sep24_guid>',
}
